import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { country },
} = checkout;

const validations = [
  Yup.object().shape({
    [country.name]: Yup.object().required(country.errorMsg),
  }),
];

export default validations;
